import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptIngresosGastos (reporte) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Ingresos-Gastos",
        Subject: "IngresosGastos",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      let colsPeriodo = [ '' ];
      let ingresos = [];
      let colsTotalesIngresos = [ '' ];
      let gastos = [];
      let colsTotalesGastos = [ '' ];
      let colsResultado = [ '' ];

      /* Recuperamos los datos de las cuentas de ingresos/gastos */
      let periodo = reporte.periodos[0];

      if (periodo) {
        if (periodo.ingresos) {
          periodo.ingresos.forEach(cuentaIngresos => {
            ingresos.push({
              id: cuentaIngresos.id,
              periodos: [ cuentaIngresos.nombre.trim() ]
            })
          });  
        }

        if (periodo.gastos) {
          periodo.gastos.forEach(cuentaGastos => {
            gastos.push({
              id: cuentaGastos.id,
              periodos: [ cuentaGastos.nombre.trim() ]
            })
          });  
        }
      }

      reporte.periodos.forEach(periodo => {
        colsPeriodo.push(this.$options.filters.fecha(periodo.periodo));
        colsTotalesIngresos.push(periodo.totalIngresos);
        colsTotalesGastos.push(periodo.totalGastos);
        colsResultado.push(periodo.resultado);

        if (periodo.ingresos) {
          periodo.ingresos.forEach(cuentaIngresos => {

            let cuenta = ingresos.find(c => c.id == cuentaIngresos.id);
            if (cuenta) {
              cuenta.periodos.push(cuentaIngresos.importe);
            }
          });  
        }

        if (periodo.gastos) {
          periodo.gastos.forEach(cuentaGastos => {

            let cuenta = gastos.find(c => c.id == cuentaGastos.id);
            if (cuenta) {
              cuenta.periodos.push(cuentaGastos.importe);
            }
          });  
        }
      });

      data.push([...colsPeriodo]);

      if (ingresos) {
        ingresos.forEach(cuentaIngresos => {
          data.push([...cuentaIngresos.periodos]);    
        });
      }

      data.push([...colsTotalesIngresos]);

      if (gastos) {
        gastos.forEach(cuentaGastos => {
          data.push([...cuentaGastos.periodos]);    
        });
      }

      data.push([...colsTotalesGastos]);

      data.push([...colsResultado]);
      

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "ingresos-gastos");
      XLSX.writeFile(wb, "ingresos-gastos.xlsx");

      return;
    },
  }
}
